module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e062cd6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Terms.vue
// module id = 1135
// module chunks = 0